// angular
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { CoreService } from '../../../core/core.service';

// others
import { AppService } from '../../../app.service';
import { AuthService } from '../../../core/auth.service';
import { Router } from '@angular/router';
import { ProfileComponent } from '../profile.component';
import { ProfileService } from '../profile.service';
import { KlenicoMeService } from '../../me.service';

@Component({
    selector: 'me-sr-dashboard-card',
    templateUrl: './dashboard-card.component.html',
    styleUrls: ['./dashboard-card.component.scss'],
    providers: [ProfileService]
})

export class ProfileDashboardCardComponent extends ProfileComponent implements OnInit {
    data: any;
    url = 'self-evaluation/dashboard-card';
    submitted: boolean;
    checked: boolean = false;

    @Input() callApi = true;
    @Input() blockData = false;

    constructor(
        public appService: AppService,
        public fb: FormBuilder,
        public translate: TranslateService,
        public coreService: CoreService,
        public router: Router,
        public profileService: ProfileService,
        public authService: AuthService,
        public meService: KlenicoMeService
    ) {
        super(appService, translate, coreService, router, profileService, authService, meService);
    }

    ngOnInit() {
        if (this.callApi) {
            this.getContent();
            this.translate.onLangChange.subscribe(value => {
                this.getContent();
            });
        } else {
            this.data = this.blockData['content'];
        }
    }

    getContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            this.data = res['story']['content'] ?? [];
            this.appService.isLoading = false;
        });
    }
}
